import { createContext } from "react";

const adminLeloContext = createContext();

export default adminLeloContext;
